import { Route, Switch, Redirect } from 'react-router-dom';
import Header from './components/Header';
import Studio from './components/Studio';
import Button from './styled/Button/Button';
import GlobalStyles from './styled/globalStyles';
import { initAnalytics } from './services/analytics';

initAnalytics();

const App: React.FC = () => (
  <div className="App">
    <GlobalStyles />
    <Header />
    <Switch>
      <Route exact path="/:type/:template" component={Studio} />
      <Route
        path="/custom"
        render={() => (
          <div style={{ margin: '3rem' }}>
            <Button loading size="small" />
            <Button loading />
            <Button loading size="large" />
            <Button loading size="small">
              Start
            </Button>
            <Button disabled>Start</Button>
            <br />
            <br />
            <Button loading varient="secondary">
              Start
            </Button>
            <br />
            <br />
            <Button loading varient="link">
              Start
            </Button>
            <br />
            <br />
            <Button loading varient="muted">
              Start
            </Button>
            <br />
            <br />
            <Button loading danger>
              Start
            </Button>
            <br />
            <br />
            <Button loading danger varient="secondary">
              Start
            </Button>
            <br />
            <br />
            <Button loading danger varient="link">
              Start
            </Button>
            <br />
            <br />
            <Button loading danger varient="muted">
              Start
            </Button>
            <br />
            <br />
          </div>
        )}
      />
      <Route render={() => <Redirect to="/showcase/simple" />} />
    </Switch>
  </div>
);

export default App;
